module.exports = __webpack_public_path__ + "assets/img/partners2.5bf63e18.jpg";